const iniVX=2e3
const iniVY=2e3
const iniNZ=5e3
const ETFactoredLoadSource = ["ACI 318-08","ACI 318-08 - Appendix D"]

export default function AnchorLoadClass() {
    this.vX=iniVX,
    this.vY=iniVY,
    this.nZ=iniNZ,
    this.categoryCOrHigher=!1,
    this.factorLoadSource=ETFactoredLoadSource[0]
}

AnchorLoadClass.prototype.Init = function(load) {
    load && (
        this.vX=load.vX,
        this.vY=load.vY,
        this.nZ=load.nZ,
        this.categoryCOrHigher=load.categoryCOrHigher,
        this.factorLoadSource=load.factorLoadSource
    )
}

AnchorLoadClass.prototype.Chapter9 = function() {
    return this.factorLoadSource===ETFactoredLoadSource[0]
}
